// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"267":"8f5137b8","531":"bddbe404"}[chunkId] + ".chunk.js";
};